module.exports = __webpack_public_path__ + "static/media/tree_22.0e372c8a.jpg";